import { render, staticRenderFns } from "./departments.vue?vue&type=template&id=bb8336ac&scoped=true"
import script from "./departments.vue?vue&type=script&lang=js"
export * from "./departments.vue?vue&type=script&lang=js"
import style0 from "./departments.vue?vue&type=style&index=0&id=bb8336ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8336ac",
  null
  
)

export default component.exports